export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Ideas de Experimentos',
    description: 'Experimentos seguros y sencillos para hacer en el aula',
    price: 'USD 17',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c1e846ee-6372-410a-ac3a-2bb5e8b02932.jpg',
  },
  {
    title: 'Recursos Descargables',
    description: 'Fichas, tarjetas y material listo para imprimir',
    price: 'USD 15',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/b244801e-9f03-4d7e-beef-79470c83c974.jpg',
  },
  {
    title: 'Tutoriales y Videoclases',
    description: 'Explicaciones en video para apoyar cada tema',
    price: 'USD 19',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/86f73b6e-8af3-404e-85c0-eb8d39c5f938.jpg',
  },
  {
    title: 'Guías de Laboratorio',
    description: 'Prácticas paso a paso con método y resultados',
    price: 'USD 15',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c9fdd959-aef1-487c-b5b4-aa1c59da7bd2.jpg',
  },
  {
    title: 'Comunidad de Docentes',
    description: 'Comparte ideas y recursos con otras profes de Ciencias',
    price: 'USD 20',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4a29b1c9-1c44-45d9-9c1b-a17dda5de51e.jpg',
  },
]

export interface Testimonial {
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    quote: '«Dejé de improvisar. Ahora llego a clase con todo preparado y se nota en mis alumnos.»',
    name: 'Carla M.',
    role: 'Primaria',
  },
  {
    quote: '«Me ahorró horas cada semana. Es exactamente lo que necesitaba.»',
    name: 'Rocío D.',
    role: 'Secundaria',
  },
  {
    quote: '«Los exámenes y rúbricas ya listos me cambiaron la vida.»',
    name: 'Javier P.',
    role: 'Biología',
  },
  {
    quote: '«El material es claro y los chicos se enganchan mucho más.»',
    name: 'Lucía R.',
    role: 'Ciencias',
  },
  {
    quote: '«Descargué e imprimí el mismo día. Cero complicaciones.»',
    name: 'Andrés G.',
    role: 'Secundaria',
  },
  {
    quote: '«Los bonos por sí solos ya valen la compra.»',
    name: 'Marina T.',
    role: 'Primaria',
  },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Qué incluye el pack Biología Lista?',
    answer: '10 tomos completos (Primaria + Secundaria), +300 páginas y los 5 bonos de regalo.',
  },
  {
    question: '¿Sirve para mi nivel o curso?',
    answer: 'Sí. Cubre Primaria y Secundaria, organizado por nivel y tema.',
  },
  {
    question: '¿En qué formato lo recibo?',
    answer: 'En PDF, listo para imprimir o usar en pantalla.',
  },
  {
    question: '¿Cómo accedo después de comprar?',
    answer: 'Recibes el acceso de descarga inmediata, al instante.',
  },
  {
    question: '¿Puedo usarlo todo el año?',
    answer: 'Sí. Tienes acceso de por vida, sin mensualidades.',
  },
  {
    question: '¿Los bonos están incluidos?',
    answer: 'Sí, los 5 bonos son gratis con tu compra.',
  },
  {
    question: '¿Y si no me convence?',
    answer: 'Tienes 7 días de garantía. Te devolvemos el 100%.',
  },
  {
    question: '¿Es pago único?',
    answer: 'Sí. Pagas una sola vez, sin suscripciones.',
  },
]
